var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOpenNewWindow = function SvgIconOpenNewWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.79 2.558a.5.5 0 0 1 .5-.5h4.2a.5.5 0 0 1 .5.5v4.2a.5.5 0 1 1-1 0V3.765l-6.138 6.138a.5.5 0 0 1-.707-.707l6.138-6.138H17.29a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.001 3.01 3 3.014v17.97l.001.006.003.005.005.003.006.001H20.99l.005-.004.003-.005.001-.006V12.06a.5.5 0 0 1 1 0v8.925c0 .56-.454 1.015-1.015 1.015H3.015C2.455 22 2 21.546 2 20.985V3.015C2 2.455 2.454 2 3.015 2h8.75a.5.5 0 1 1 0 1h-8.75l-.006.001-.005.003z",
    clipRule: "evenodd"
  })));
};
export default SvgIconOpenNewWindow;